import React, { useCallback, useEffect, useState } from 'react';
import { useAuth } from '../context/AuthContext';
import { playlistApi } from '../utils/api';

export default function SharedPlaylistsPage() {
  const { token } = useAuth();

  const [playlists, setPlaylists] = useState([]);
  const [error, setError]         = useState('');
  const [loading, setLoading]     = useState(true);
  const [copied, setCopied]       = useState('');

  const load = useCallback(async () => {
    setLoading(true);
    try {
      const all = await playlistApi.list(token);
      setPlaylists((all || []).filter(p => p.shared));
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  }, [token]);

  useEffect(() => { load(); }, [load]);

  const shareUrl = (playlistToken) =>
    `${window.location.origin}/playlists/public/${playlistToken}`;

  const copyLink = async (playlistToken) => {
    try {
      await navigator.clipboard.writeText(shareUrl(playlistToken));
      setCopied(playlistToken);
      setTimeout(() => setCopied(''), 2000);
    } catch {
      alert(shareUrl(playlistToken));
    }
  };

  if (loading) return <div className="text-center mt-5"><div className="spinner-border" /></div>;

  return (
    <>
      <h2 className="mb-4">Shared Playlists</h2>

      {error && <div className="alert alert-danger">{error}</div>}

      {playlists.length === 0 ? (
        <p className="text-muted">
          No shared playlists yet. Open a playlist and check <strong>Shared</strong> to share it.
        </p>
      ) : (
        <div className="list-group">
          {playlists.map(pl => (
            <div key={pl.playlist_id} className="list-group-item">
              <div className="d-flex justify-content-between align-items-start">
                <div>
                  <div className="fw-semibold">{pl.title}</div>
                  <small className="text-muted">
                    {pl.allow_random ? 'Random order · ' : ''}
                    Modified {new Date(pl.modified_date).toLocaleDateString()}
                  </small>
                </div>
                <div className="d-flex gap-2 flex-shrink-0 ms-3">
                  <a
                    href={shareUrl(pl.token)}
                    target="_blank"
                    rel="noreferrer"
                    className="btn btn-sm btn-outline-primary"
                  >
                    View
                  </a>
                  <button
                    className={`btn btn-sm ${copied === pl.token ? 'btn-success' : 'btn-outline-secondary'}`}
                    onClick={() => copyLink(pl.token)}
                  >
                    {copied === pl.token ? 'Copied!' : 'Copy Link'}
                  </button>
                </div>
              </div>
              <div className="mt-2">
                <input
                  readOnly
                  className="form-control form-control-sm text-muted"
                  value={shareUrl(pl.token)}
                  onFocus={e => e.target.select()}
                />
              </div>
            </div>
          ))}
        </div>
      )}
    </>
  );
}
